<main>
    <section class="header-relatorio">
        <div class="img-logo" ></div>
        <!-- <img id="background" src="../../../../../assets/img/png/Cabeçalho.png" /> -->
        <!-- <img src="../../../../../assets/img/png/logo-atualizada.PNG" /> -->
    </section>
    <section>
        <div class="ans">
            <span class="logo-ans">
                ANS - n° 355151
            </span>
        </div>
    </section>
</main>